import { render } from "./MiniWizardManagerWithLoading.vue?vue&type=template&id=558ac2bc"
import script from "./MiniWizardManagerWithLoading.vue?vue&type=script&lang=js"
export * from "./MiniWizardManagerWithLoading.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__